<template>
  <el-dialog
    :close-on-press-escape="false"
    custom-class="layout-dialog"
    title="未入力一括催促"
    top="5vh"
    width="580px"
    :visible.sync="dialogVisible"
    append-to-body
    @close="close"
  >
    <div>
      <vab-form :model="form" :rules="rules" label-width="0px">
        <vab-row :gutter="10">
          <vab-col :span="14" class="input_per">
            <vab-date-picker
              type="date"
              label="入力期限"
              value-format="yyyy/MM/dd"
              format="yyyy/MM/dd"
              prop="planContractStartDate"
              label-width="110px"
              validate="required"
            />
          </vab-col>
        </vab-row>
      </vab-form>
      <div class="mg12 flex_end">
        <vab-button :btn-list="btnUpdate" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'UrgeNo',
    data() {
      return {
        form: {},
        rules: {},
        dialogVisible: false,
        btnUpdate: [
          {
            name: '未入力一括催促',
            type: 'button',
            hidden: false,
            icon: 'mail_send_line',
            widht: 'auto',
          },
        ],
      }
    },
    methods: {
      close() {
        this.dialogVisible = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .input_per {
    ::v-deep .el-form-item__label {
      text-align: left;
    }
  }
</style>
